export default __webpack_public_path__ + "static/media/026-hypotenuse.0c45561a.svg";